<template>
  <!-- 未知身份游客进入后需选择身份 -->
  <div class="current-wrapper">

    <div class="text-box">
 <h1>声明</h1>

      <p class="text-summ">
        喜乐互联网医院是经银川市场审批服务管理局、卫健委、大数据局三部门共同审批监管，并由银川市公安局网安支队负责数据安全监督，具有营业执照和医疗机构执业许可证的正规互联网医院。
      </p>
      <p class="text-summ"> 本平台保证您注册时所有个人信息的安全性，并且保证不会将您的个人信息用于他处。如本平台泄漏您的个人信息或将您的个人信息用于他处，本平台愿承担相关法律责任。
      </p>
      <div class="cerimg-box">
        <div class="cerimg-item"  @click="previewImage(previewList, 0)">
         <img src="@/assets/images/license.jpg">

          <p>营业执照</p>
        </div>
        <div class="cerimg-item" @click="previewImage(previewList, 1)">
             <img src="@/assets/images/certificate.jpg">
          <p>执业许可证</p>

        </div>
      </div>
      <p class="text-summ tips-block">
        <icon icon-class="tips"></icon> 友情提示：在其他互联网医院注册或进行诊疗时，也一定要看对方是否具体相关的营业执照及医疗机构许可证，如不具备，您的个人权益将无法得到保障。
      </p>
    </div>

    <div class="role-wrapper">


      <h1>请选择</h1>
      <div class="choose-control">
        <div class="choose-item doctor" @click="chooseRole('doctor')">
          <div class="choose-icon">
            <img src="@/assets/images/user-doctor.png">
            <div class="choose-checkbox" :class="{'checked': role == 1}">
              <icon icon-class="check-mark"></icon>
            </div>
          </div>
          <p>我是医生</p>
        </div>
        <div class="choose-item patient" @click="chooseRole('patient')">
          <div class="choose-icon">
            <img src="@/assets/images/user-patient.png">
            <div class="choose-checkbox" :class="{'checked': role == 2}">
              <icon icon-class="check-mark"></icon>
            </div>
          </div>
          <p>我是患者</p>
        </div>
      </div>
      <div class="submit"><button class="submit-button" @click="confrimRole">确定</button></div>
    </div>
    <x-dialog v-if="dialogShow" @close="dialogShow = false" title="确认身份选择">
      <div class="confrim-wrapper">
        <div class="confrim-text">当前选择身份为 <span>「{{role | roleFilter}}」</span> ，确认后身份将无法变更</div>
        <div class="control">
          <button class="cancel" @click="dialogShow = false">取消</button>
          <button class="confirm" @click="submitRole" :disabled="sending">确定并下一步</button>
        </div>
      </div>
    </x-dialog>
        <van-image-preview v-model="previewShow" :images="previewList" :start-position="imageIndex"></van-image-preview>
  </div>
</template>

<style lang="less" scoped>
  .current-wrapper
  {
    padding: 10px 15px 0;
    .text-box{
      h1{
        text-align: center;
        font-size: 22px;
      }
      padding:13px;
      border-radius: 5px;

      border:dashed 1px #f0f0f0;
      .text-summ{
        line-height: 20px;
        margin-top: 3px;
        text-indent: 2em;
        font-size: 13px;
      }
      .tips-block{
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        padding: 7px 2px;
        background: rgba(245,164,30,0.05);
        border-radius: 2px;
        color: #F5A41E;
        font-size: 12px;
        line-height: 18px;
        svg{
          position: relative;
          top: 3px;
          flex-shrink: 0;
          margin-right: 6px;
          font-size: 12px;
          line-height: 18px;

          color: #F5A41E;
        }
      }
      .cerimg-box{
        margin-top: 5px;
        display: flex;
        justify-content: space-around;
        align-items: center;
    .cerimg-item{
          width: 80px;
          text-align: center;
          img{
               width: 100%;
          }
        }
        p{font-size: 14px;color:#ff6207;font-weight: bold;}
      }
    }

    .role-wrapper{
  padding: 16px 25px 0;

    h1{
      font-size: 22px;
      line-height: 33px;
      color: @black;
      font-weight: bold;
    }
    .choose-control{
      margin-top: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      .choose-icon{
        position: relative;
        width: 100%;
        img{
          width: 100%;
        }
        .choose-checkbox{
          position: absolute;
          right: 0;
          bottom: 0;
          width: 30px;
          height: 30px;
          border: 2px solid #99CED0;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #CCC;
          font-size: 15px;
          border-radius: 50%;
          background: #FFF;
          box-shadow: 0px 2px 6px 0px rgba(0,132,138,0.2);
          svg{
            position: relative;
            top: 1px;
            color: #CCC;
          }
          &.checked{
            background: @xile;
            border-color: @xile;
            color: #FFF;
            svg{
              color: #FFF;
            }
          }
        }
      }
      p{
        margin-top: 20px;
        font-size: 16px;
        line-height: 22px;
        color: @black;
      }
      .choose-item{
        width: 95px;
        text-align: center;
        &.doctor{
          margin-right: 76px;
        }
      }
    }
    .submit{
      margin-top: 30px;
      button{
        @button-base();
        width: 100%;
        height: 36px;
        font-size: 14px;
      }
    }
    }
  }
  // 弹窗样式
  .confrim-wrapper{
    padding: 40px 0 32px;
    text-align: center;
    .confrim-text{
      width: 75%;
      font-size: 15px;
      line-height: 21px;
      color: #333;
      text-align: left;
      margin: 0 auto;
      font-weight: bold;
      span{
        color: @error;
      }
    }
    .control{
      margin-top: 32px;
      display: flex;
      justify-content: center;
      align-items: center;
      button{
        @button-base();
        height: 36px;
        font-size: 14px;
        width: 128px;
        &.cancel{
          background: #FFF;
          border: 1px solid #999;
          color: #999;
          margin-right: 15px;
        }
        &.confirm{}
      }
    }
  }
</style>

<script type="text/javascript">
  import xDialog from '@/components/Common/dialog'
  export default {
    data() {
      return {
        role: null,
        sending: false,
        dialogShow: false,
        previewShow: false,
        previewList: [
          require('@/assets/images/license.jpg'),
          require('@/assets/images/certificate.jpg')
        ],
        imageIndex: 0
      }
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      }
    },
    created(){
     console.log(this.licenseimg)
    },
    components: {
      xDialog
    },
    methods: {
      previewImage(list, index) {
        //console.log(list)
        this.previewList = list;
        this.imageIndex = index;
        this.previewShow = true;
      },
      chooseRole(value) {
        if (value == 'doctor') {
          this.role = 1;
        } else {
          this.role = 2;
        }
      },
      confrimRole() {
        if (!this.role) {
          this.$notify('请选择您的身份');
          return;
        }
        this.dialogShow = true;
      },
      submitRole() {
        this.sending = true;
        this.$root.post('/setUserRole', {
          role: this.role,
          user_token: this.userInfo.user_token
        }).then(data => {
          this.sending = false;
          if (data.status == 1) {
            // 更新用户的uid,头像,身份
            this.userInfo.user_id = data.user_id;
            this.userInfo.avatar = data.avatar;
            this.userInfo.role = this.role;
            store.set('userInfo', this.userInfo);
            this.$store.commit('setUserInfo', this.userInfo);
            if (this.role == 1) {
              this.$router.push('/doctor/baseinfo');
            } else {
              this.$router.push('/patient/code-binding');
            }
          } else {
            this.$notify(data.msg);
          }
        })

      }
    },
    filters: {
      roleFilter(role) {
        switch (role) {
          case 1:
            return '医生';
            break;
          case 2:
            return '患者';
            break;
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Public/characterChoose.vue